import { LocalizationKeys, type LocalizationKey } from '../../i18n/keys'

/**
 * Genre enum - жанры контента
 */
export enum Genre {
  UNSPECIFIED = 0,
  ACTION = 1,
  ADVENTURE = 2,
  ANIMATION = 4,
  BIOGRAPHY = 8,
  COMEDY = 16,
  CRIME = 32,
  DOCUMENTARY = 64,
  DRAMA = 128,
  FAMILY = 256,
  FANTASY = 512,
  FILM_NOIR = 1024,
  GAME_SHOW = 2048,
  HISTORY = 4096,
  HORROR = 8192,
  MUSIC = 16384,
  MUSICAL = 32768,
  NEWS = 65536,
  REALITY_TV = 131072,
  ROMANCE = 262144,
  SCI_FI = 524288,
  SHORT = 1048576,
  SPORT = 2097152,
  TALK_SHOW = 4194304,
  THRILLER = 8388608,
  WAR = 16777216,
  WESTERN = 33554432,
}

/**
 * Mapping of Genre enum values to i18n keys
 */
export const GENRE_I18N_KEYS: Record<Genre, LocalizationKey> = {
  [Genre.UNSPECIFIED]: LocalizationKeys.GENRE_UNSPECIFIED,
  [Genre.ACTION]: LocalizationKeys.GENRE_ACTION,
  [Genre.ADVENTURE]: LocalizationKeys.GENRE_ADVENTURE,
  [Genre.ANIMATION]: LocalizationKeys.GENRE_ANIMATION,
  [Genre.BIOGRAPHY]: LocalizationKeys.GENRE_BIOGRAPHY,
  [Genre.COMEDY]: LocalizationKeys.GENRE_COMEDY,
  [Genre.CRIME]: LocalizationKeys.GENRE_CRIME,
  [Genre.DOCUMENTARY]: LocalizationKeys.GENRE_DOCUMENTARY,
  [Genre.DRAMA]: LocalizationKeys.GENRE_DRAMA,
  [Genre.FAMILY]: LocalizationKeys.GENRE_FAMILY,
  [Genre.FANTASY]: LocalizationKeys.GENRE_FANTASY,
  [Genre.FILM_NOIR]: LocalizationKeys.GENRE_FILM_NOIR,
  [Genre.GAME_SHOW]: LocalizationKeys.GENRE_GAME_SHOW,
  [Genre.HISTORY]: LocalizationKeys.GENRE_HISTORY,
  [Genre.HORROR]: LocalizationKeys.GENRE_HORROR,
  [Genre.MUSIC]: LocalizationKeys.GENRE_MUSIC,
  [Genre.MUSICAL]: LocalizationKeys.GENRE_MUSICAL,
  [Genre.NEWS]: LocalizationKeys.GENRE_NEWS,
  [Genre.REALITY_TV]: LocalizationKeys.GENRE_REALITY_TV,
  [Genre.ROMANCE]: LocalizationKeys.GENRE_ROMANCE,
  [Genre.SCI_FI]: LocalizationKeys.GENRE_SCI_FI,
  [Genre.SHORT]: LocalizationKeys.GENRE_SHORT,
  [Genre.SPORT]: LocalizationKeys.GENRE_SPORT,
  [Genre.TALK_SHOW]: LocalizationKeys.GENRE_TALK_SHOW,
  [Genre.THRILLER]: LocalizationKeys.GENRE_THRILLER,
  [Genre.WAR]: LocalizationKeys.GENRE_WAR,
  [Genre.WESTERN]: LocalizationKeys.GENRE_WESTERN,
}
